import { BASE_API_URL } from '@config/environment';
import { errorLogHandler } from '@shared/errorLogHandler';
import { DeleteGeneratedReceiptResult, UploadResult } from '@shared/types';
import axios, { CancelTokenSource } from 'axios';
import { DeliveryReceipt } from '@shared/interfaces.ts';

export async function generateReceipt(
  file: File,
  processObjectId: string,
  cancelToken: CancelTokenSource
): Promise<UploadResult> {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${BASE_API_URL}/delivery_receipt/${processObjectId}`,
      formData,
      {
        cancelToken: cancelToken.token,
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );

    return {
      status: 'SUCCESS',
      image: response.data.image,
    };
  } catch (error: Error | unknown) {
    errorLogHandler(error);
    if (axios.isCancel(error)) {
      console.log('Request canceled', error.message);

      return {
        status: 'CANCELED',
        name: file.name,
      };
    }

    if (!(error instanceof Error)) {
      return {
        status: 'FAILED',
        name: file.name,
        size: file.size,
        type: file.type,
        error: new Error('Unknown error'),
      };
    }

    return {
      status: 'FAILED',
      name: file.name,
      size: file.size,
      type: file.type,
      error,
    };
  }
}

export const getDeliveryReceipt = async (processObjectId: string) => {
  const url = `${BASE_API_URL}/delivery_receipt/${processObjectId}`;
  const res = await axios.get<DeliveryReceipt>(url);
  return res.data;
};

type GetDeliveryReceiptResponseDocument = {
  document: string;
};

type DeliveryReceiptProps = {
  processObjectId: string;
  documentType: string;
  fileName: string;
};

export const getDeliveryReceiptDocument = async ({
  processObjectId,
  documentType,
  fileName,
}: DeliveryReceiptProps) => {
  const url = `${BASE_API_URL}/documents/${processObjectId}?document_type=${documentType}&filename=${fileName}`;

  const res = await axios.get<GetDeliveryReceiptResponseDocument>(url);
  return res.data.document;
};

export async function removeGeneratedReceipt(
  processObjectId: string
): Promise<DeleteGeneratedReceiptResult> {
  try {
    await axios.delete(`${BASE_API_URL}/delivery_receipt/${processObjectId}`);
    return {
      status: 'SUCCESS',
    };
  } catch (error: Error | unknown) {
    errorLogHandler(error);
    return {
      status: 'FAILED',
    };
  }
}
